// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Belt_Result = require("bs-platform/lib/js/belt_Result.js");
var SourceRepository$SF = require("./SourceRepository.bs.js");

function mapFilterMap(x, f, g) {
  return Belt_Option.getWithDefault(Belt_Option.map(x, (function (y) {
                    return Belt_List.map(Belt_List.keep(y, f), g);
                  })), /* [] */0);
}

function mapMap(x, f) {
  return mapFilterMap(x, (function (param) {
                return true;
              }), f);
}

function t_encode(v) {
  switch (v.TAG | 0) {
    case /* Gerrit */0 :
        return [
                "Gerrit",
                Decco.stringToJson(v._0)
              ];
    case /* Pagure */1 :
        return [
                "Pagure",
                Decco.stringToJson(v._0)
              ];
    case /* GitLab */2 :
        return [
                "GitLab",
                Decco.stringToJson(v._0)
              ];
    case /* GitHub */3 :
        return [
                "GitHub",
                Decco.stringToJson(v._0)
              ];
    case /* Git */4 :
        return [
                "Git",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Gerrit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Gerrit */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Git" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Git */4,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "GitHub" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GitHub */3,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "GitLab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GitLab */2,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Pagure" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Pagure */1,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function cloneUrl(connection, project) {
  switch (connection.TAG | 0) {
    case /* Gerrit */0 :
    case /* Pagure */1 :
    case /* GitLab */2 :
    case /* GitHub */3 :
        return connection._0 + ("/" + project);
    case /* Git */4 :
        return connection._0 + ("/" + (project + ".git"));
    
  }
}

function webUrl(connection, project) {
  switch (connection.TAG | 0) {
    case /* Gerrit */0 :
        return connection._0 + ("/plugins/gitiles/" + (project + "/+/HEAD"));
    case /* Pagure */1 :
        return connection._0 + ("/" + (project + "/tree"));
    case /* GitLab */2 :
    case /* GitHub */3 :
        return connection._0 + ("/" + project);
    case /* Git */4 :
        return "";
    
  }
}

function commitUrl(connection, project) {
  switch (connection.TAG | 0) {
    case /* Gerrit */0 :
        return connection._0 + ("/plugins/gitiles/" + (project + "/+log"));
    case /* Pagure */1 :
    case /* GitLab */2 :
    case /* GitHub */3 :
        return connection._0 + ("/" + (project + "/commits"));
    case /* Git */4 :
        return "";
    
  }
}

function changesUrl(connection, project) {
  switch (connection.TAG | 0) {
    case /* Gerrit */0 :
        return connection._0 + ("/q/status:open+project:" + project);
    case /* Pagure */1 :
        return connection._0 + ("/" + (project + "/pull-requests"));
    case /* GitLab */2 :
        return connection._0 + ("/" + (project + "/merge_requests"));
    case /* GitHub */3 :
        return connection._0 + ("/" + (project + "/pulls"));
    case /* Git */4 :
        return "";
    
  }
}

function fromV1(connections, name) {
  var c = Belt_List.head(Belt_List.keep(connections, (function (c) {
              return c.name === name;
            })));
  if (c === undefined) {
    return {
            TAG: /* Error */1,
            _0: name
          };
  }
  var match = c.connection_type;
  var match$1 = c.base_url;
  switch (match) {
    case /* Git */0 :
        if (match$1 !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    TAG: /* Git */4,
                    _0: match$1
                  }
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: c.name
                };
        }
    case /* Pagure */1 :
        if (match$1 !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    TAG: /* Pagure */1,
                    _0: match$1
                  }
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: c.name
                };
        }
    case /* Gerrit */2 :
        if (match$1 !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    TAG: /* Gerrit */0,
                    _0: match$1
                  }
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: c.name
                };
        }
    case /* Gitlab */3 :
        if (match$1 !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    TAG: /* GitLab */2,
                    _0: match$1
                  }
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: c.name
                };
        }
    case /* Github */4 :
        if (match$1 !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    TAG: /* GitHub */3,
                    _0: match$1
                  }
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: c.name
                };
        }
    
  }
}

var Connection = {
  t_encode: t_encode,
  t_decode: t_decode,
  cloneUrl: cloneUrl,
  webUrl: webUrl,
  commitUrl: commitUrl,
  changesUrl: changesUrl,
  fromV1: fromV1
};

function getLocal(res, name) {
  return Belt_Option.flatMap(res.repos, (function (repos) {
                return Belt_List.head(Belt_List.keep(repos, (function (r) {
                                  return r.name === name;
                                })));
              }));
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "location",
                t_encode(v.location)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      var $$location = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
      if ($$location.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  name: name._0,
                  description: description._0,
                  location: $$location._0
                }
              };
      }
      var e = $$location._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".location" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromV1$1(res, project, tenant, sr) {
  var name = SourceRepository$SF.getName(sr);
  var isLocal = getLocal(res, name);
  var connectionName = Belt_Option.getWithDefault(SourceRepository$SF.getConnection(sr), Belt_Option.getWithDefault(project.connection, Belt_Option.getWithDefault(tenant.default_connection, "")));
  var description = Belt_Option.map(isLocal, (function (r) {
          return r.description;
        }));
  return Belt_Result.flatMap(fromV1(Belt_Option.getWithDefault(res.connections, /* [] */0), connectionName), (function ($$location) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          name: name,
                          description: description,
                          location: $$location
                        }
                      };
              }));
}

var SourceRepository = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromV1: fromV1$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "description",
                Decco.stringToJson(v.description)
              ],
              [
                "source-repositories",
                Decco.listToJson(t_encode$1, v.source_repositories)
              ],
              [
                "website",
                Decco.optionToJson(Decco.stringToJson, v.website)
              ],
              [
                "documentation",
                Decco.optionToJson(Decco.stringToJson, v.documentation)
              ],
              [
                "issue-tracker-url",
                Decco.optionToJson(Decco.stringToJson, v.issue_tracker_url)
              ],
              [
                "mailing-lists",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.stringToJson, param);
                      }), v.mailing_lists)
              ],
              [
                "contacts",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.stringToJson, param);
                      }), v.contacts)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      var source_repositories = Decco.listFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "source-repositories"), null));
      if (source_repositories.TAG === /* Ok */0) {
        var website = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "website"), null));
        if (website.TAG === /* Ok */0) {
          var documentation = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "documentation"), null));
          if (documentation.TAG === /* Ok */0) {
            var issue_tracker_url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issue-tracker-url"), null));
            if (issue_tracker_url.TAG === /* Ok */0) {
              var mailing_lists = Decco.optionFromJson((function (param) {
                      return Decco.listFromJson(Decco.stringFromJson, param);
                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "mailing-lists"), null));
              if (mailing_lists.TAG === /* Ok */0) {
                var contacts = Decco.optionFromJson((function (param) {
                        return Decco.listFromJson(Decco.stringFromJson, param);
                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "contacts"), null));
                if (contacts.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            name: name._0,
                            description: description._0,
                            source_repositories: source_repositories._0,
                            website: website._0,
                            documentation: documentation._0,
                            issue_tracker_url: issue_tracker_url._0,
                            mailing_lists: mailing_lists._0,
                            contacts: contacts._0
                          }
                        };
                }
                var e = contacts._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".contacts" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = mailing_lists._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".mailing-lists" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = issue_tracker_url._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".issue-tracker-url" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = documentation._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".documentation" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = website._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".website" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = source_repositories._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".source-repositories" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function fromV1$2(res, tenant, project) {
  return {
          name: project.name,
          description: project.description,
          source_repositories: Belt_List.flatten(Belt_List.map(project.sourceRepositories, (function (sr) {
                      var sr$1 = fromV1$1(res, project, tenant, sr);
                      if (sr$1.TAG === /* Ok */0) {
                        return {
                                hd: sr$1._0,
                                tl: /* [] */0
                              };
                      } else {
                        return /* [] */0;
                      }
                    }))),
          website: project.website,
          documentation: project.documentation,
          issue_tracker_url: project.issue_tracker_url,
          mailing_lists: project.mailing_lists,
          contacts: project.contacts
        };
}

var Project = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromV1: fromV1$2
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "projects",
                Decco.listToJson(t_encode$2, v.projects)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var projects = Decco.listFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "projects"), null));
    if (projects.TAG === /* Ok */0) {
      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    name: name._0,
                    projects: projects._0,
                    description: description._0,
                    url: url._0
                  }
                };
        }
        var e = url._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".url" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = projects._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".projects" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function fromV1$3(defaultTenant, res, tenant) {
  var isMyProject = function (project) {
    var projectTenant = project.tenant;
    if (projectTenant !== undefined) {
      return tenant.name === projectTenant;
    } else {
      return tenant.name === defaultTenant;
    }
  };
  return {
          name: tenant.name,
          projects: mapFilterMap(res.projects, isMyProject, (function (param) {
                  return fromV1$2(res, tenant, param);
                })),
          description: tenant.description,
          url: tenant.url
        };
}

var Tenant = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromV1: fromV1$3
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "tenants",
                Decco.listToJson(t_encode$3, v.tenants)
              ],
              [
                "puburl",
                Decco.stringToJson(v.puburl)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tenants = Decco.listFromJson(t_decode$3, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tenants"), null));
  if (tenants.TAG === /* Ok */0) {
    var puburl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "puburl"), null));
    if (puburl.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                tenants: tenants._0,
                puburl: puburl._0
              }
            };
    }
    var e = puburl._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".puburl" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = tenants._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tenants" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromV1$4(defaultTenant, res) {
  var f = function (param) {
    return fromV1$3(defaultTenant, res, param);
  };
  return {
          tenants: mapFilterMap(res.tenants, (function (param) {
                  return true;
                }), f),
          puburl: res.puburl
        };
}

function toV1(_v2) {
  return {
          projects: undefined,
          connections: undefined,
          tenants: undefined,
          repos: undefined,
          groups: undefined,
          puburl: ""
        };
}

var SFV1;

exports.SFV1 = SFV1;
exports.mapFilterMap = mapFilterMap;
exports.mapMap = mapMap;
exports.Connection = Connection;
exports.getLocal = getLocal;
exports.SourceRepository = SourceRepository;
exports.Project = Project;
exports.Tenant = Tenant;
exports.t_encode = t_encode$4;
exports.t_decode = t_decode$4;
exports.fromV1 = fromV1$4;
exports.toV1 = toV1;
/* No side effect */
